import Vue from 'vue';

import store from '../../store/';
import TestBasket from './TestBasket.vue';
import Loading from '../Loading.vue';

const $mount = document.getElementById('order-testbasket');

if ($mount) {
    new Vue({
        el: $mount,
        store,
        render() {
            return <TestBasket />;
        },
    });

    // loading overlay
    new Vue({
        el: document.getElementById('order-loading-modal'),
        store,
        render() {
            return this.$store.state.loadingModalVisible ? <Loading text={this.$store.state.loadingModalMessage} /> : null;
        },
    });
}



// WEBPACK FOOTER //
// ./static/js/Order/components/TestBasket/index.js